export function DividerBlockComponent() {
	return <hr className="my-4 border-kumo-line" />;
}
